// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"238":"58ea07b5","633":"aedc8648"}[chunkId] + ".chunk.js");